export const pickerRootStyles = {
  display: 'flex',
  padding: 0.5,
  gap: 0.25,
};
